<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="train-menu">
  <div class="panel-left" *ngIf="showHeader" [style.top]='panelLeftPosY' [style.left]='panelLeftPosX' [style.width]='leftWidth' [style.height]='leftHeight'>

    <a href="javascript:void(0)" *ngIf="user && user.isUserManagerOrDirector && showHeader" class="menu-item-link" (click)='updateAllocStation();'>
            Update allocation station
    </a>
    <a href="javascript:void(0)" *ngIf="user && !user.isUserManagerOrDirector && showHeader" class="menu-item-link disabled">
            Update allocation station
    </a>

    <a href="javascript:void(0)" *ngIf="user && user.isUserManagerOrDirector && showHeader" class="menu-item-link" (click)='deleteAllocStation();'>
            Delete allocation station
    </a>
    <a href="javascript:void(0)" *ngIf="user && !user.isUserManagerOrDirector && showHeader" class="menu-item-link disabled">
            Delete allocation station
    </a>

  </div>
  <div class="panel-right" id="contextPanelID" [style.top]='panelRightPosY' [style.left]='panelRightPosX'>
    <div class="train-infoPanel">
      <ul>
        <li>
          <span class="train-label">
            Division
					</span>
          <span class="train-value">
            {{getLmsDivision()}}
					</span>
        </li>
        <li>
          <span class="train-label">
            Allocation Station
					</span>
          <span class="train-value">
						{{getAllocationStation()}}
					</span>
        </li>
        <li>
          <span class="train-label">
            City
					</span>
          <span class="train-value">
						{{getStationCityState()}}
					</span>
        </li>
        <li>
          <span class="train-label">
            Desk
					</span>
          <span class="train-value">
						{{getLmsDesk()}}
					</span>
        </li>
        <li>
          <span class="train-label">
            4 Axles
					</span>
          <span class="train-value">
						{{station && station.axleFourAllotment ? getIntegerVal(station.axleFourAllotment) : '-'}}
					</span>
        </li>
        <li>
          <span class="train-label">
             6 Axles
					</span>
          <span class="train-value">
						{{station && station.axleSixAllotment ? getIntegerVal(station.axleSixAllotment) : '-'}}
					</span>
        </li>
        <li *ngIf="isPtc4AxleEnable">
          <span class="train-label">
            PTC 4 Axles
					</span>
          <span class="train-value">
						{{station && station.ptcFourAxleAllotment ? getIntegerVal(station.ptcFourAxleAllotment) : '-'}}
					</span>
        </li>
        <li *ngIf="isPtc6AxleEnable">
          <span class="train-label">
            PTC 6 Axles
					</span>
          <span class="train-value">
						{{station && station.ptcSixAxleAllotment ? getIntegerVal(station.ptcSixAxleAllotment) : '-'}}
					</span>
        </li>
        <li>
          <span class="train-label">
            RCL 4 Axles
					</span>
          <span class="train-value">
						{{station && station.rclFourAxleAllotment ? getIntegerVal(station.rclFourAxleAllotment) : '-'}}
					</span>
        </li>
        <li>
          <span class="train-label">
            RCL 6 Axles
					</span>
          <span class="train-value">
						{{station && station.rclSixAxleAllotment ? getIntegerVal(station.rclSixAxleAllotment) : '-'}}
					</span>
        </li>
        <li *ngIf="isPtcRcl4AxleEnable">
          <span class="train-label">
            PTC RCL 4 Axles
					</span>
          <span class="train-value">
						{{station && station.ptcRclFourAxleAllotment ? getIntegerVal(station.ptcRclFourAxleAllotment) : '-'}}
					</span>
        </li>
        <li *ngIf="isPtcRcl6AxleEnable">
          <span class="train-label">
            PTC RCL 6 Axles
					</span>
          <span class="train-value">
						{{station && station.ptcRclSixAxleAllotment ? getIntegerVal(station.ptcRclSixAxleAllotment) : '-'}}
					</span>
        </li>
        <!-- <li>
          <span class="train-label">
            Platforms
					</span>
          <span class="train-value">
						{{station && station.platform ? getIntegerVal(station.platform) : '-'}}
					</span>
        </li> -->
        <li>
          <span class="train-label">
            Slugs
					</span>
          <span class="train-value">
						{{station && station.slugAllotment ? getIntegerVal(station.slugAllotment) : '-'}}
					</span>
        </li>
        <li *ngIf="isPtcSlugEnable">
          <span class="train-label">
            PTC Slugs
					</span>
          <span class="train-value">
						{{station && station.ptcSlugAllotment ? getIntegerVal(station.ptcSlugAllotment) : '-'}}
					</span>
        </li>
        <li>
          <span class="train-label">
            Road Terminal 1 / Transit
					</span>
          <span class="train-value">
						{{getRoadTerminalOne()}} / {{station && station.roadTerminalOneTranHours ? getTrasitHours(station.roadTerminalOneTranHours) : '-'}}
					</span>
        </li>
        <li>
          <span class="train-label">
            Road Terminal 2 / Transit
					</span>
          <span class="train-value">
						{{getRoadTerminalTwo()}} / {{station && station.roadTerminalTwoTranHours ? getTrasitHours(station.roadTerminalTwoTranHours): '-'}}
					</span>
        </li>
      </ul>
    </div>
  </div>
</div>